<template>
  <div
    v-if="siteStore.getMessages.length > 0"
    class="alert spacing"
    role="alert"
  >
    <a
      v-for="message in siteStore.getMessages"
      :key="`flash-message-${message.toLowerCase().split(' ').join('-')}`"
      class="button-green"
      href="/cart"
    >
      {{ message }}
    </a>
  </div>
</template>

<script>
  import { useSiteStore } from '~/stores/site';

  export default {
    props: {
      message: {
        type: String,
        default: '',
      },
    },
    setup() {
      const siteStore = useSiteStore();
      return { siteStore };
    },
    created() {
      if (this.message) {
        this.siteStore.addMessage(this.message);
      }
    },
  };
</script>
